import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';

import { TranslocoModule } from '@jsverse/transloco';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NgArrayPipesModule, NgStringPipesModule } from 'ngx-pipes';

import { UiIconsModule } from 'ui-icons';

import { MainNavAboutUsComponent } from './components/main-nav-about-us/main-nav-about-us.component';
import { MainNavBusinessDesktopForUserComponent } from './components/main-nav-business-desktop-for-user/main-nav-business-desktop-for-user.component';
import { MainNavBusinessDesktopComponent } from './components/main-nav-business-desktop/main-nav-business-desktop.component';
import { MainNavBusinessItemsMobileComponent } from './components/main-nav-business-items-mobile/main-nav-business-items-mobile.component';
import { MainNavGuardComponent } from './components/main-nav-guard/main-nav-guard.component';
import { MainNavLanguageFlagComponent } from './components/main-nav-language-flag/main-nav-language-flag.component';
import { MainNavLanguagesMobileComponent } from './components/main-nav-languages-mobile/main-nav-languages-mobile.component';
import { MainNavLanguagesComponent } from './components/main-nav-languages/main-nav-languages.component';
import { MainNavLoginComponent } from './components/main-nav-login/main-nav-login.component';
import { MainNavMobileFooterForUserComponent } from './components/main-nav-mobile-footer-for-user/main-nav-mobile-footer-for-user.component';
import { MainNavMobileFooterComponent } from './components/main-nav-mobile-footer/main-nav-mobile-footer.component';
import { MainNavMobileComponent } from './components/main-nav-mobile/main-nav-mobile.component';
import { MainNavPlatformDesktopComponent } from './components/main-nav-platform-desktop/main-nav-platform-desktop.component';
import { MainNavPlatformItemsForUserMobileComponent } from './components/main-nav-platform-items-for-user-mobile/main-nav-platform-items-for-user-mobile.component';
import { MainNavPlatformItemsMobileComponent } from './components/main-nav-platform-items-mobile/main-nav-platform-items-mobile.component';
import { MainNavProfilesDesktopComponent } from './components/main-nav-profiles-desktop/main-nav-profiles-desktop.component';
import { MainNavProfilesMobileComponent } from './components/main-nav-profiles-mobile/main-nav-profiles-mobile.component';
import { MainNavRequestDemoComponent } from './components/main-nav-request-demo/main-nav-request-demo.component';
import { MainNavSingleItemExternalComponent } from './components/main-nav-single-item-external/main-nav-single-item-external.component';
import { MainNavSingleItemComponent } from './components/main-nav-single-item/main-nav-single-item.component';
import { MainNavUserComponent } from './components/main-nav-user/main-nav-user.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { ReadingProgressBarComponent } from './components/reading-progress-bar/reading-progress-bar.component';

import { FooterPlatformComponent } from '../../../footer/components/footer-platform/footer-platform.component';
import { ProfileLogoModule } from '../../../widgets/profile-logo/profile-logo.module';
import { SearchInputModule } from '../../../widgets/search-input/search-input.module';
import { UserLogoModule } from '../../../widgets/user-logo/user-logo.module';

/**
 * Header Widget module
 */
@NgModule({
  imports: [
    // *** Angular modules ***
    CommonModule,
    RouterModule,
    // *** 3th party ***
    MatBadgeModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    NgArrayPipesModule,
    TranslocoModule,
    // SmartHead modules
    SearchInputModule,
    UserLogoModule,
    ProfileLogoModule,
    NgStringPipesModule,
    UiIconsModule,
    FooterPlatformComponent,
    MainNavLanguagesComponent,
    MainNavLanguageFlagComponent,
    MainNavLanguagesMobileComponent,
    MainNavUserComponent,
    NzToolTipModule
  ],
  declarations: [
    MainNavComponent,
    ReadingProgressBarComponent,
    MainNavPlatformDesktopComponent,
    MainNavProfilesDesktopComponent,
    MainNavLoginComponent,
    MainNavBusinessDesktopComponent,
    MainNavGuardComponent,
    MainNavRequestDemoComponent,
    MainNavAboutUsComponent,
    MainNavBusinessDesktopForUserComponent,
    MainNavSingleItemComponent,
    MainNavSingleItemExternalComponent,
    MainNavMobileComponent,
    MainNavMobileFooterComponent,
    MainNavMobileFooterForUserComponent,
    MainNavBusinessItemsMobileComponent,
    MainNavPlatformItemsForUserMobileComponent,
    MainNavProfilesMobileComponent,
    MainNavPlatformItemsMobileComponent
  ],
  exports: [
    MainNavComponent,
    MainNavPlatformDesktopComponent,
    MainNavBusinessDesktopComponent,
    MainNavGuardComponent
  ]
})
export class HeaderModule {}
